// import React, { useState } from 'react';
// import {
//   Box,
//   Typography,
//   Grid,
//   Card,
//   CardMedia,
//   CardContent,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   Button,
//   Chip,
//   Stack,
//   Divider,
// } from '@mui/material';
// import {
//   ZoomIn as ZoomInIcon,
//   Download as DownloadIcon,
//   OpenInNew as OpenInNewIcon,
//   Close as CloseIcon,
//   Photo as PhotoIcon,
//   Collections as CollectionsIcon,
// } from '@mui/icons-material';

// const API_URL = process.env.REACT_APP_URL || 'http://localhost:3060';

// const ImageGallery = ({ images, title, category, maxColumns = 4 }) => {
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [open, setOpen] = useState(false);

//   // Function to build the complete image URL
//   const getImageUrl = (imgPath) => {
//     if (!imgPath) return '';

//     // If it's already a full URL (http/https), use as-is
//     if (/^https?:\/\//i.test(imgPath)) {
//       return imgPath;
//     }

//     // If it starts with a slash, prepend API_URL
//     if (imgPath.startsWith('/')) {
//       return `${API_URL}${imgPath}`;
//     }

//     // For relative paths without leading slash
//     return `${API_URL}/${imgPath}`;
//   };

//   if (!images || images.length === 0) return null;

//   const handleImageClick = (image) => {
//     setSelectedImage(getImageUrl(image));
//     setOpen(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//     setSelectedImage(null);
//   };

//   const handleDownload = (image) => {
//     const link = document.createElement('a');
//     link.href = getImageUrl(image);
//     link.download = `${category}_${Date.now()}.jpg`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   return (
//     <>
//       <Card variant="outlined" sx={{ mb: 3 }}>
//         <CardContent>
//           <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
//             <CollectionsIcon color="primary" />
//             <Typography variant="h6" fontWeight="bold">
//               {title}
//             </Typography>
//             <Chip 
//               label={`${images.length} images`} 
//               size="small" 
//               color="primary" 
//               variant="outlined" 
//             />
//           </Stack>
//           <Divider sx={{ mb: 2 }} />
          
//           <Grid container spacing={2}>
//             {images.map((image, index) => (
//               <Grid item xs={12} sm={6} md={12/maxColumns} key={index}>
//                 <Card 
//                   sx={{ 
//                     cursor: 'pointer',
//                     transition: 'transform 0.2s',
//                     '&:hover': {
//                       transform: 'scale(1.02)',
//                       boxShadow: 3
//                     }
//                   }}
//                 >
//                   <Box sx={{ position: 'relative' }}>
//                     <CardMedia
//                       component="img"
//                       height="200"
//                       image={getImageUrl(image)}
//                       alt={`${title} ${index + 1}`}
//                       onClick={() => handleImageClick(image)}
//                       sx={{
//                         objectFit: 'cover',
//                         '&:hover': {
//                           opacity: 0.9
//                         }
//                       }}
//                     />
//                     <Box sx={{ 
//                       position: 'absolute', 
//                       top: 8, 
//                       right: 8,
//                       display: 'flex',
//                       gap: 1,
//                       opacity: 0,
//                       transition: 'opacity 0.2s',
//                       '&:hover': {
//                         opacity: 1
//                       }
//                     }}>
//                       <IconButton
//                         size="small"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handleImageClick(image);
//                         }}
//                         sx={{ bgcolor: 'rgba(255,255,255,0.9)' }}
//                       >
//                         <ZoomInIcon fontSize="small" />
//                       </IconButton>
//                       <IconButton
//                         size="small"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handleDownload(image);
//                         }}
//                         sx={{ bgcolor: 'rgba(255,255,255,0.9)' }}
//                       >
//                         <DownloadIcon fontSize="small" />
//                       </IconButton>
//                     </Box>
//                   </Box>
//                   <CardContent sx={{ p: 1 }}>
//                     <Typography variant="caption" color="text.secondary">
//                       Image {index + 1}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </CardContent>
//       </Card>

//       {/* Full-size Image Dialog */}
//       <Dialog 
//         open={open} 
//         onClose={handleClose}
//         maxWidth="lg"
//         fullWidth
//       >
//         <DialogTitle>
//           <Stack direction="row" justifyContent="space-between" alignItems="center">
//             <Typography variant="h6">{title}</Typography>
//             <IconButton onClick={handleClose}>
//               <CloseIcon />
//             </IconButton>
//           </Stack>
//         </DialogTitle>
//         <DialogContent>
//           {selectedImage && (
//             <Box sx={{ textAlign: 'center', p: 2 }}>
//               <img
//                 src={selectedImage}
//                 alt="Full size"
//                 style={{ 
//                   maxWidth: '100%', 
//                   maxHeight: '70vh',
//                   objectFit: 'contain'
//                 }}
//               />
//               <Stack direction="row" spacing={2} justifyContent="center" sx={{ mt: 2 }}>
//                 <Button
//                   variant="outlined"
//                   startIcon={<OpenInNewIcon />}
//                   onClick={() => window.open(selectedImage, '_blank')}
//                 >
//                   Open in New Tab
//                 </Button>
//                 <Button
//                   variant="contained"
//                   startIcon={<DownloadIcon />}
//                   onClick={() => handleDownload(images.find(img => getImageUrl(img) === selectedImage))}
//                 >
//                   Download
//                 </Button>
//               </Stack>
//             </Box>
//           )}
//         </DialogContent>
//       </Dialog>
//     </>
//   );
// };

// export default ImageGallery;
import React, { useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Chip,
  Stack,
  Divider,
} from '@mui/material';
import {
  ZoomIn as ZoomInIcon,
  Download as DownloadIcon,
  OpenInNew as OpenInNewIcon,
  Close as CloseIcon,
  Collections as CollectionsIcon,
} from '@mui/icons-material';

const API_URL = process.env.REACT_APP_URL || 'http://localhost:3060';

const ImageGallery = ({
  images,
  title,
  category,
  maxColumns = 4,
  aspectRatio = '1 / 1', // 👈 change to '4 / 3', '16 / 9', etc.
}) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [open, setOpen] = useState(false);

  const getImageUrl = (imgPath) => {
    if (!imgPath) return '';
    if (/^https?:\/\//i.test(imgPath)) return imgPath;
    return imgPath.startsWith('/')
      ? `${API_URL}${imgPath}`
      : `${API_URL}/${imgPath}`;
  };

  if (!images?.length) return null;

  const handleOpen = (image) => {
    setSelectedImage(getImageUrl(image));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
  };

  const handleDownload = (image) => {
    const link = document.createElement('a');
    link.href = getImageUrl(image);
    link.download = `${category}_${Date.now()}.jpg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Card variant="outlined" sx={{ mb: 3 }}>
        <CardContent>
          <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
            <CollectionsIcon color="primary" />
            <Typography variant="h6" fontWeight="bold">
              {title}
            </Typography>
            <Chip
              label={`${images.length} images`}
              size="small"
              color="primary"
              variant="outlined"
            />
          </Stack>

          <Divider sx={{ mb: 2 }} />

          <Grid container spacing={2}>
            {images.map((image, index) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={Math.floor(12 / maxColumns)}
                key={index}
              >
                <Card
                  sx={{
                    cursor: 'pointer',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    '&:hover': {
                      transform: 'scale(1.02)',
                      boxShadow: 4,
                    },
                  }}
                >
                  {/* Aspect Ratio Wrapper */}
                  <Box
                    sx={{
                      position: 'relative',
                      width: '100%',
                      aspectRatio,
                      overflow: 'hidden',
                      bgcolor: 'grey.100',
                    }}
                    onClick={() => handleOpen(image)}
                  >
                    <Box
                      component="img"
                      src={getImageUrl(image)}
                      alt={`${title} ${index + 1}`}
                      sx={{
                        position: 'absolute',
                        inset: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      }}
                    />

                    {/* Hover Actions */}
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        display: 'flex',
                        gap: 1,
                        opacity: 0,
                        transition: 'opacity 0.2s',
                        '.MuiCard-root:hover &': { opacity: 1 },
                      }}
                    >
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleOpen(image);
                        }}
                        sx={{ bgcolor: 'rgba(255,255,255,0.9)' }}
                      >
                        <ZoomInIcon fontSize="small" />
                      </IconButton>

                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDownload(image);
                        }}
                        sx={{ bgcolor: 'rgba(255,255,255,0.9)' }}
                      >
                        <DownloadIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  </Box>

                  <CardContent sx={{ p: 1 }}>
                    <Typography variant="caption" color="text.secondary">
                      Image {index + 1}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>

      {/* Full Image Dialog */}
      <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
        <DialogTitle>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">{title}</Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Stack>
        </DialogTitle>

        <DialogContent>
          {selectedImage && (
            <Box sx={{ textAlign: 'center', p: 2 }}>
              <Box
                component="img"
                src={selectedImage}
                alt="Full size"
                sx={{
                  maxWidth: '100%',
                  maxHeight: '70vh',
                  objectFit: 'contain',
                }}
              />

              <Stack direction="row" spacing={2} justifyContent="center" sx={{ mt: 2 }}>
                <Button
                  variant="outlined"
                  startIcon={<OpenInNewIcon />}
                  onClick={() => window.open(selectedImage, '_blank')}
                >
                  Open in New Tab
                </Button>
                <Button
                  variant="contained"
                  startIcon={<DownloadIcon />}
                  onClick={() =>
                    handleDownload(
                      images.find((img) => getImageUrl(img) === selectedImage)
                    )
                  }
                >
                  Download
                </Button>
              </Stack>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ImageGallery;
